// Module
var code = "<a class=\"baloon__close js-close\" title=\"Close baloon\">\n    <span class=\"icon\">\n        <svg class=\"svg-icon\"><use xmlns:xlink=\"http://www.w3.org/1999/xlink\" xlink:href=\"#svgicon--close\"></use></svg>\n    </span>\n</a>\n<!-- template like \"balloon--copy-dashboard\" -->";
// Exports
export default code;